// components/AnnouncementBanner.tsx
import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import { COLORS } from '../../Constants/styles';
import AccentButton from '../Common/AccentButton';
import { Home_IMG } from '../../Constants/ImageConstants';
import brochurePDF from '../../Assets/grassroots-brochure.pdf';

export const AnnouncementBanner = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        px: { xs: 2, md: 0, lg: 6 },
        py: { xs: 4, md: 6, lg: 10 },
        backgroundColor: COLORS.white,
        position: 'relative',
        zIndex: 5,
      }}
    >
      <Box
        sx={{
          maxWidth: 1400,
          width: '100%',
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-between',
          alignItems: 'stretch',
          gap: { xs: 4, md: 2 },
        }}
      >
        {/* Left Image */}
        <Box
          component={motion.div}
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          sx={{
            flex: '1 1 31%',
            height: { xs: 200, sm: 280, md: 540 },
            backgroundImage: `url(${Home_IMG.AnnouncementSection2})`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            borderRadius: '20px',
            order: { xs: 1, md: 1 },
          }}
        />

        {/* Center Content */}
        <Box
          sx={{
            flex: '1 1 31%',
            backgroundColor: COLORS.greyBG,
            borderRadius: '20px',
            boxShadow: 4,
            px: { xs: 2, sm: 3 },
            py: { xs: 3, sm: 4 },
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            order: { xs: 2, md: 2 },
          }}
        >
          {/* "NEW" Label */}
          {/* <Box sx={{ alignItems: 'center' }}>
            <Typography
              variant="subtitle1"
              sx={{
                display: 'inline-block',
                backgroundColor: COLORS.accentLime,
                color: '#000',
                borderRadius: '4px',
                px: 2,
                py: 0.5,
                mb: 3,
              }}
            >
              New
            </Typography>
          </Box> */}

          {/* Text Content */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6 }}
          >
            <Typography
              variant="h2"
              sx={{
                mb: 3,
                color: COLORS.pureBlack,
              }}
            >
              Structured Sports Education Framework for Schools 
              <br />
              {/* Classes Start in September! */}
            </Typography>

            <Typography
              variant="body2"
              sx={{
                mb: 2,
                fontSize: { xs: '0.9rem', sm: '1rem' }, 
                textAlign: 'center',
              }}
            >
             • Curriculum-Led • Platform-Supported <br/> • Institution-Aligned 
            </Typography>

            <Typography
              variant="body2"
              sx={{
                mb: 4,
                color: COLORS.accentBlackTransparent,
                fontSize: { xs: '0.9rem', sm: '1rem' },
                fontFamily: 'Inter',
                lineHeight: 1.4,
              }}
            >
             Helping schools implement a complete Sports Education system aligned with NEP 2020 and the National Curriculum Framework.
            </Typography>

            <AccentButton
                label="Download Brochure"
                href={brochurePDF}
                download="Grassroots-Sports-Brochure.pdf"
                target="_blank"
                rel="noopener noreferrer"
              />
          </motion.div>
        </Box>

        {/* Right Image */}
        <Box
          component={motion.div}
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          sx={{
            flex: '1 1 31%',
            width: '100%',
            minHeight: { xs: 200, sm: 280, md: 540 },
            backgroundImage: `url(${Home_IMG.AnnouncementSection1})`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            borderRadius: '20px',
            order: { xs: 3, md: 3 },
            flexShrink: 0,
          }}
        />
      </Box>
    </Box>
  );
};
